import { render, staticRenderFns } from "./ProductPropertyForm.vue?vue&type=template&id=56fce87b&"
import script from "./ProductPropertyForm.vue?vue&type=script&lang=js&"
export * from "./ProductPropertyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports